import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowDownWall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowDownWall"><Path d="M13 17.5859L16.25 14.3359L17.6641 15.75L12 21.4141L6.33594 15.75L7.75 14.3359L11 17.5859V7H13V17.5859Z" fill="currentColor"/><Path d="M20 5H4V3H20V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowDownWall;
